import Datepicker from "../../shared/components/Datepicker/Datepicker";
import { countries } from "../../shared/const/countries.const";
import { Bq1GeneralInformationM } from "../models/bq1-general-information.model";
import { formDate } from "../services/baltic-forms.utils";
import React from "react";

export function Bq1OwnershipAndOperation(
  form: Bq1GeneralInformationM,
  updateForm: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void,
  updateDate: (date: Date | null, field: string) => void,
  readonly: boolean,
) {
  return (
    <div>
      <h2 className="mb-2 mt-[120px] text-lg font-semibold">Ownership and Operation</h2>

      <div className="flex-rght flex">
        <h3 className="text-md mb-2 mt-8 rounded bg-green pl-2 pr-2 font-medium text-white">Registered Owner</h3>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Registered Owner Name */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Name</label>
          <input
            disabled={readonly}
            type="text"
            name="registeredOwnerName"
            value={form.registeredOwnerName}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Registered Owner Full Address */}
        <div className="col-span-2">
          <label className="block text-sm font-bold">Full address</label>
          <textarea
            disabled={readonly}
            name="registeredOwnerFullAddress"
            value={form.registeredOwnerFullAddress}
            onChange={updateForm}
            className="mt-1 h-16 w-full resize-none rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Country */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Country</label>
          <select
            disabled={readonly}
            name="registeredOwnerCountry"
            value={form.registeredOwnerCountry}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          >
            <option value=""></option>
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        {/* Office phone */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office telephone</label>
          <input
            disabled={readonly}
            type="text"
            name="registeredOwnerOfficeTel"
            value={form.registeredOwnerOfficeTel}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Office fax */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office fax number</label>
          <input
            disabled={readonly}
            type="text"
            name="registeredOwnerOfficeFax"
            value={form.registeredOwnerOfficeFax}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Telex */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office telex number</label>
          <input
            disabled={readonly}
            type="text"
            name="registeredOwnerOfficeTelex"
            value={form.registeredOwnerOfficeTelex}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Email */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office Email address</label>
          <input
            disabled={readonly}
            type="text"
            name="registeredOwnerOfficeEmail"
            value={form.registeredOwnerOfficeEmail}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Website */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Web site</label>
          <input
            disabled={readonly}
            type="text"
            name="registeredOwnerWebsite"
            value={form.registeredOwnerWebsite}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      {/* Parent company / group */}
      <div className="flex-rght flex">
        <h3 className="text-md mb-2 mt-8 rounded bg-green pl-2 pr-2 font-medium text-white">Parent company/group</h3>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Name */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Parent company/group to which the owner belongs</label>
          <input
            disabled={readonly}
            type="text"
            name="parentCompanyGroup"
            value={form.parentCompanyGroup}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Address */}
        <div className="col-span-2">
          <label className="block text-sm font-bold">Address</label>
          <textarea
            disabled={readonly}
            name="parentCompanyAddress"
            value={form.parentCompanyAddress}
            onChange={updateForm}
            className="mt-1 h-16 w-full resize-none rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Tel */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Tel</label>
          <input
            disabled={readonly}
            type="text"
            name="parentCompanyTel"
            value={form.parentCompanyTel}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Fax */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Fax</label>
          <input
            disabled={readonly}
            type="text"
            name="parentCompanyFax"
            value={form.parentCompanyFax}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Telex */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Telex</label>
          <input
            disabled={readonly}
            type="text"
            name="parentCompanyTelex"
            value={form.parentCompanyTelex}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Email */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Email</label>
          <input
            disabled={readonly}
            type="text"
            name="parentCompanyEmail"
            value={form.parentCompanyEmail}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Website */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Website</label>
          <input
            disabled={readonly}
            type="text"
            name="parentCompanyWeb"
            value={form.parentCompanyWeb}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      {/* Technical Operator */}
      <div className="flex-rght flex">
        <h3 className="text-md mb-2 mt-8 rounded bg-green pl-2 pr-2 font-medium text-white">Technical Operator</h3>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Operator Name */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Operator Name</label>
          <input
            disabled={readonly}
            type="text"
            name="technicalOperatorName"
            value={form.technicalOperatorName}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Full Address */}
        <div className="col-span-2">
          <label className="block text-sm font-bold">Full Address</label>
          <textarea
            disabled={readonly}
            name="technicalOperatorFullAddress"
            value={form.technicalOperatorFullAddress}
            onChange={updateForm}
            className="mt-1 h-16 w-full resize-none rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Country */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Country</label>
          <select
            disabled={readonly}
            name="technicalOperatorCountry"
            value={form.technicalOperatorCountry}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          >
            <option value=""></option>
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        {/* Office Tel */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office telephone</label>
          <input
            disabled={readonly}
            type="text"
            name="technicalOperatorOfficeTel"
            value={form.technicalOperatorOfficeTel}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Office Fax */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office fax</label>
          <input
            disabled={readonly}
            type="text"
            name="technicalOperatorOfficeFax"
            value={form.technicalOperatorOfficeFax}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Office Telex */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office telex</label>
          <input
            disabled={readonly}
            type="text"
            name="technicalOperatorOfficeTelex"
            value={form.technicalOperatorOfficeTelex}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Office Email */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office email</label>
          <input
            disabled={readonly}
            type="text"
            name="technicalOperatorOfficeEmail"
            value={form.technicalOperatorOfficeEmail}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Website */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">WebSite</label>
          <input
            disabled={readonly}
            type="text"
            name="technicalOperatorWebsite"
            value={form.technicalOperatorWebsite}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Company IMO Number */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Company IMO number</label>
          <input
            disabled={readonly}
            type="text"
            name="technicalOperatorCompanyImoNumber"
            value={form.technicalOperatorCompanyImoNumber}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      {/* Commercial Operator */}
      <div className="flex-rght flex">
        <h3 className="text-md mb-2 mt-8 rounded bg-green pl-2 pr-2 font-medium text-white">Commercial Operator</h3>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Name */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Name</label>
          <input
            disabled={readonly}
            type="text"
            name="commercialOperatorName"
            value={form.commercialOperatorName}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Full Address */}
        <div className="col-span-2">
          <label className="block text-sm font-bold">Full Address</label>
          <textarea
            disabled={readonly}
            name="commercialOperatorFullAddress"
            value={form.commercialOperatorFullAddress}
            onChange={updateForm}
            className="mt-1 h-16 w-full resize-none rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Country */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Country</label>
          <select
            disabled={readonly}
            name="commercialOperatorCountry"
            value={form.commercialOperatorCountry}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          >
            <option value=""></option>
            {countries.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>

        {/* Office Tel */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office telephone</label>
          <input
            disabled={readonly}
            type="text"
            name="commercialOperatorOfficeTel"
            value={form.commercialOperatorOfficeTel}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Office Fax */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office fax</label>
          <input
            disabled={readonly}
            type="text"
            name="commercialOperatorOfficeFax"
            value={form.commercialOperatorOfficeFax}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Office Telex */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office telex</label>
          <input
            disabled={readonly}
            type="text"
            name="commercialOperatorOfficeTelex"
            value={form.commercialOperatorOfficeTelex}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Office Email */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Office email</label>
          <input
            disabled={readonly}
            type="text"
            name="commercialOperatorOfficeEmail"
            value={form.commercialOperatorOfficeEmail}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Website */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Web site</label>
          <input
            disabled={readonly}
            type="text"
            name="commercialOperatorWebsite"
            value={form.commercialOperatorWebsite}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      {/* Disponent Owner */}
      <div className="flex-rght flex">
        <h3 className="text-md mb-2 mt-8 rounded bg-green pl-2 pr-2 font-medium text-white">Disponent Owner</h3>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Name */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Name</label>
          <input
            disabled={readonly}
            type="text"
            name="disponentOwnerName"
            value={form.disponentOwnerName}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Full Address */}
        <div className="col-span-2">
          <label className="block text-sm font-bold">Full Address</label>
          <textarea
            disabled={readonly}
            name="disponentOwnerFullAddress"
            value={form.disponentOwnerFullAddress}
            onChange={updateForm}
            className="mt-1 h-16 w-full resize-none rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Tel */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Tel</label>
          <input
            disabled={readonly}
            type="text"
            name="disponentOwnerTel"
            value={form.disponentOwnerTel}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Fax */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Fax</label>
          <input
            disabled={readonly}
            type="text"
            name="disponentOwnerFax"
            value={form.disponentOwnerFax}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Telex */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Telex</label>
          <input
            disabled={readonly}
            type="text"
            name="disponentOwnerTelex"
            value={form.disponentOwnerTelex}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Email */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Email</label>
          <input
            disabled={readonly}
            type="text"
            name="disponentOwnerEmail"
            value={form.disponentOwnerEmail}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Website */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">Web Site</label>
          <input
            disabled={readonly}
            type="text"
            name="disponentOwnerWebsite"
            value={form.disponentOwnerWebsite}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>

      {/* Misc */}
      <div className="mb-8 grid grid-cols-4 gap-4">
        {/* Is vessel owned/time charter/bareboat/comm mgmt */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">
            Is vessel owned, on time charter, bareboat or in commercial mgmt?
          </label>
          <input
            disabled={readonly}
            type="text"
            name="isVesselOwnedOrCharter"
            value={form.isVesselOwnedOrCharter}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>

        {/* Since */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">
            Since
            <br />
            &nbsp;
          </label>
          <Datepicker
            disabled={readonly}
            selected={formDate(form.disponentOwnerSince)}
            onChange={(date) => updateDate(date, "disponentOwnerSince")}
          />
        </div>

        {/* Number of vessels in Disponent owners fleet */}
        <div className="col-span-1">
          <label className="block text-sm font-bold">
            Number of vessels in Disponent owners fleet
            <br />
            &nbsp;
          </label>
          <input
            disabled={readonly}
            type="number"
            name="numberOfVesselsInDisponentFleet"
            value={form.numberOfVesselsInDisponentFleet}
            onChange={updateForm}
            className="mt-1 w-full rounded-md border p-2 focus:outline-none focus:ring"
          />
        </div>
      </div>
    </div>
  );
}
